import { SPACING } from '@qflow/theme'

export const SIDEBAR_HORIZONTAL_PADDING = SPACING.TINY
